import { LegalLayout } from "../components/LegalLayout";
import { REFUNDS_PAGE } from "../data/legalPages";

export default function Refunds() {
  return <LegalLayout page={REFUNDS_PAGE} testId="refunds-page" />;
}
